import { ElectronicReceiptsActions } from 'constants/ActionsTypesTs'
import {
	IConsultElectronicReceiptsResponse,
	IGetElectronicReceiptsHeadersParams,
	IValidateElectronicReceiptResponse
} from 'models/ElectronicReceipts'

export interface valueState {
	electronicReceiptsHeaders: any
	confirmHeaders: any
	messageError: string
	confirmParams: any
	headerFilters: IGetElectronicReceiptsHeadersParams
	electronicReceiptsSent: IValidateElectronicReceiptResponse | null
	statusElectronicReceipts: IConsultElectronicReceiptsResponse | null
}

const initialState = {
	electronicReceiptsHeaders: null,
	confirmHeaders: null,
	messageError: '',
	confirmParams: null,
	headerFilters: {
		idOperacion: '',
		page_number: 1,
		page_size: 10,
		sucursal: ''
	},
	electronicReceiptsSent: null,
	statusElectronicReceipts: null
}

function rootReducer(state: valueState = initialState, action: any) {
	switch (action.type) {
		case ElectronicReceiptsActions.GET_ELECTRONIC_RECEIPTS_HEADERS:
			return { ...state, electronicReceiptsHeaders: null }
		case ElectronicReceiptsActions.GET_ELECTRONIC_RECEIPTS_HEADERS_SUCCESS:
			return { ...state, electronicReceiptsHeaders: action.payload }
		case ElectronicReceiptsActions.CONFIRM_ELECTRONIC_RECEIPTS_HEADERS:
			return {
				...state,
				confirmHeaders: null,
				messageError: '',
				confirmParams: action.payload
			}
		case ElectronicReceiptsActions.CONFIRM_ELECTRONIC_RECEIPTS_HEADERS_SUCCESS:
			return { ...state, confirmHeaders: action.payload, confirmParams: null }
		case ElectronicReceiptsActions.CONFIRM_ELECTRONIC_RECEIPTS_HEADERS_ERROR:
			return { ...state, messageError: action.payload }
		case ElectronicReceiptsActions.SET_ELECTRONIC_RECEIPTS_HEADER_FILTERS:
			return { ...state, headerFilters: action.payload }
		case ElectronicReceiptsActions.CLEAR_ELECTRONIC_RECEIPTS_HEADER_FILTERS:
			return {
				...state,
				headerFilters: {
					idOperacion: '',
					page_number: 1,
					page_size: 10,
					sucursal: ''
				}
			}
		case ElectronicReceiptsActions.VALIDATE_ELECTRONIC_RECEIPTS:
			return { ...state, electronicReceiptsSent: null }
		case ElectronicReceiptsActions.VALIDATE_ELECTRONIC_RECEIPTS_SUCCESS:
			return { ...state, electronicReceiptsSent: action.payload }
		case ElectronicReceiptsActions.CONSULT_ELECTRONIC_RECEIPTS:
			return { ...state }
		case ElectronicReceiptsActions.CONSULT_ELECTRONIC_RECEIPTS_SUCCESS:
			return { ...state, statusElectronicReceipts: action.payload }
		case ElectronicReceiptsActions.CANCEL_ELECTRONIC_RECEIPTS_SUCCESS:
			return { ...state, statusElectronicReceipts: null }
		default:
			return state
	}
}

export default rootReducer
